import { Hub } from "aws-amplify/utils";

const tokenName = "dolToken";

export const setDOLToken = value => {
	sessionStorage.setItem(tokenName, value);
	Hub.dispatch("auth", { event: "dolToken" });
	return tokenName;
};

export const getDOLToken = () => sessionStorage.getItem(tokenName);

export const deleteDOLToken = () => {
	sessionStorage.removeItem(tokenName);
	Hub.dispatch("auth", { event: "dolToken" });
};
